export enum CtaButtonsDisplayMethod {
  Manual = 'manual',
  Automate = 'automate',
}

//be is sending us different string for automated display method, needs to be refactored in their side
export enum CtaButtonsDisplayMethodPrice {
  Manual = 'manual',
  Automate = 'automated',
}

export enum ScenarioKeys {
  Default = 'default',
  Alternative = 'alternative',
}
